/*
 * Teaser + "View More" for product content blocks.
 *
 * Port of the mobile app's isContentTruncated() rule: the control is shown only
 * when the content actually overflows its collapsed height, so short
 * descriptions render in full with no button rather than offering a "View More"
 * that reveals nothing.
 */
(function () {
  'use strict';

  var OPEN_LABEL = 'View Less';
  var CLOSED_LABEL = 'View More';
  // Breathing room above a collapsed block, clear of any sticky header.
  var TOP_MARGIN = 90;

  function measure(teaser) {
    var body = teaser.querySelector('[data-bjt-body]');
    var toggle = teaser.querySelector('[data-bjt-toggle]');
    if (!body || !toggle) return;

    // An expanded block has no clamp to measure against; leave it alone.
    if (teaser.classList.contains('is-open')) return;

    // Compare against the clamped height, so the class must be on to measure.
    teaser.classList.add('bjt--clipped');
    var overflows = body.scrollHeight > body.clientHeight + 4;

    teaser.classList.toggle('bjt--clipped', overflows);
    toggle.hidden = !overflows;
  }

  function setOpen(teaser, open) {
    var toggle = teaser.querySelector('[data-bjt-toggle]');
    var label = teaser.querySelector('[data-bjt-label]');

    teaser.classList.toggle('is-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (label) label.textContent = open ? OPEN_LABEL : CLOSED_LABEL;

    if (open) return;

    /*
     * Collapsing only removes height BELOW this block's top edge, so that edge
     * never moves and the layout needs no correction while it is still on
     * screen. The jump happens when the reader has scrolled down through the
     * expanded content: the page shortens underneath them and they are left
     * further down the document than where the section began.
     *
     * So the correction is conditional - pull the block back into view only
     * when collapsing left its top above the viewport. Reading
     * getBoundingClientRect() after the class change forces layout, so this
     * measures the collapsed position without waiting a frame.
     */
    var top = teaser.getBoundingClientRect().top;
    if (top < TOP_MARGIN) window.scrollBy(0, top - TOP_MARGIN);
  }

  function init() {
    var teasers = document.querySelectorAll('[data-bjt]');
    if (!teasers.length) return;

    teasers.forEach(function (teaser) {
      measure(teaser);

      var toggle = teaser.querySelector('[data-bjt-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        setOpen(teaser, !teaser.classList.contains('is-open'));
      });
    });

    // Reflow changes how much text fits, so a block that needed a button at one
    // width may not at another.
    var queued = false;
    window.addEventListener('resize', function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        document.querySelectorAll('[data-bjt]').forEach(measure);
      });
    });

    // Switching variant swaps the description and spec content underneath us.
    if (typeof MutationObserver === 'function') {
      teasers.forEach(function (teaser) {
        var body = teaser.querySelector('[data-bjt-body]');
        if (!body) return;
        new MutationObserver(function () { measure(teaser); })
          .observe(body, { childList: true, subtree: true, characterData: true });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
